import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostExecutive.css";

function BlogPostExecutiveRisk() {
  const conditions = [
    {
      num: "1",
      title: "안전보건관리체계가 없거나 형식만 있었다",
      desc: "안전보건 경영방침, 조직, 예산이 '문서상'으로만 존재하고 실제로 작동하지 않은 경우입니다. 만들어두고 서랍에 넣어둔 안전보건계획서는 없는 것과 같습니다.",
      signal: "서명만 있고 실행 기록이 없는 문서",
    },
    {
      num: "2",
      title: "경영책임자가 직접 점검한 기록이 없었다",
      desc: "중대재해처벌법 시행령은 경영책임자가 반기 1회 이상 안전보건 이행 상황을 직접 점검하도록 규정합니다. '보고받았다'는 것과 '직접 점검했다'는 것은 다릅니다.",
      signal: "점검 일지에 경영책임자 서명 없음",
    },
    {
      num: "3",
      title: "위험이 보고됐는데 조치한 기록이 없었다",
      desc: "현장에서 위험이 반복 보고됐는데 조치 기록이 없으면 '알고도 방치했다'는 판단이 납니다. 이 경우 사고 발생 시 면책이 거의 불가능합니다.",
      signal: "보고 기록은 있는데 조치 결과 기록 없음",
    },
  ];

  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>경영자 가이드</span>
          </div>
          <h1>사고 났을 때<br />대표이사가 처벌받는 조건 3가지</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#fce7f3", color: "#9d174d" }}>경영자 가이드</span>
            <span>2026.06.05</span>
            <span>읽기 3분</span>
          </div>
        </div>

        <article className="sm-article">

          <div className="ex-hook">
            <p>사고가 났다고 무조건 처벌받는 건 아닙니다.</p>
            <p>그런데 처벌받는 패턴은 있습니다.</p>
          </div>

          <p>중대재해처벌법 시행 4년차, 판결이 쌓이면서 윤곽이 보이기 시작했습니다. 기소된 사건들을 보면 세 가지 조건이 반복해서 등장합니다.</p>

          <div className="ex-conditions">
            {conditions.map((c) => (
              <div className="ex-condition" key={c.num}>
                <div className="ex-condition-num">{c.num}</div>
                <div className="ex-condition-body">
                  <div className="ex-condition-title">{c.title}</div>
                  <p>{c.desc}</p>
                  <div className="ex-signal">
                    <span className="ex-signal-label">🚨 위험 신호</span>
                    {c.signal}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h2 className="sm-h2">사고가 원인이 아닙니다</h2>

          <p>이 세 가지 조건을 보면 공통점이 있습니다.</p>
          <p>처벌의 원인은 사고 그 자체가 아닙니다. <strong>평소에 의무를 이행하지 않은 것</strong>이 원인입니다.</p>

          <div className="sm-insight">
            <div className="sm-insight-label">법원의 판단 기준</div>
            <p>사고가 발생했을 때, 법원이 보는 건 "왜 사고가 났는가"가 아니라<br />"경영책임자가 의무를 이행했는가"입니다.</p>
          </div>

          <p>반대로 말하면, 사고가 발생해도 세 가지 조건에 해당하지 않으면 면책이 됩니다. 실제로 그런 판례가 나오고 있습니다.</p>

          <h2 className="sm-h2">지금 우리 회사는?</h2>

          <div className="ex-self-check">
            <div className="ex-self-check-title">체크해보세요</div>
            {[
              "안전보건 경영방침이 문서로 있고, 실행 기록이 있다",
              "경영책임자가 반기 1회 이상 직접 점검하고 서명한 기록이 있다",
              "위험 보고 건에 대한 조치 결과가 기록으로 남아있다",
            ].map((item, i) => (
              <div className="ex-check-item" key={i}>
                <div className="ex-check-box"></div>
                <span>{item}</span>
              </div>
            ))}
          </div>

          <p>세 가지 모두 '예'라면 현재 기본 체계는 갖춰진 상태입니다.</p>
          <p>하나라도 '모르겠다'면, 지금 확인이 필요합니다.</p>

          <div className="sm-cta">
            <div className="sm-cta-question">더 자세한 내용이 필요하신가요?</div>
            <p>9대 의무 전체와 최신 판례, 규모별 대응 방법을<br />완전 가이드에서 확인하세요.</p>
            <div className="sm-cta-buttons">
              <Link to="/blog/serious-accident-law" className="sm-cta-btn primary">
                중대재해처벌법 완전 가이드 읽기 →
              </Link>
              <Link to="/blog/exemption-one-difference" className="sm-cta-btn secondary">
                면책된 회사와 안 된 회사의 차이 →
              </Link>
            </div>
          </div>

          <div className="blog-tags">
            {["#중대재해처벌법", "#경영책임자", "#대표이사처벌", "#안전보건의무", "#건설사경영", "#중대재해면책"].map(tag => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/exemption-one-difference" className="related-card">
                <div className="related-card-tag">경영자 가이드</div>
                <div className="related-card-title">면책된 회사와 안 된 회사, 딱 하나의 차이</div>
              </Link>
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드 [2026년]</div>
              </Link>
              <Link to="/blog/risk-assessment-5steps" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostExecutiveRisk;
